import type { FC } from 'react';

import { Icon, Pill } from '@zen/DesignSystem';
import { ActionType } from '@zen/graphql/types.generated';
import { formatTime } from '@zen/utils/dateTime';
import type { Nullable } from '@zen/utils/typescript';

import { ACTION_TYPE_LABELS, type AuditLogNode } from '../types';

interface AuditLogItemProps {
  auditLog: AuditLogNode;
}

const renderValueChange = (actionType: ActionType, oldValue?: Nullable<string>, newValue?: Nullable<string>) => {
  switch (actionType) {
    case ActionType.REMOVED:
      return <p className="line-through">{oldValue}</p>;
    case ActionType.ENTERED:
      return <p>{newValue}</p>;
    default:
      return (
        <span className="flex gap-2 items-center">
          <p className="line-through">{oldValue}</p> <Icon icon={'zicon-arrow-right'} /> <p>{newValue}</p>
        </span>
      );
  }
};

const AuditLogItem: FC<AuditLogItemProps> = ({ auditLog }) => {
  const { actionTimestamp, user, actionType, displayNewValue, displayOldValue } = auditLog;

  const actionLabel = ACTION_TYPE_LABELS[actionType] ?? actionType;
  const timeString = actionTimestamp?.split('T')[1]?.split('.')[0];
  const formattedTime = timeString ? formatTime(timeString, true) : null;

  return (
    <div className="py-2.5 flex items-center justify-between">
      <div className="flex gap-2 items-center">
        <Pill className="font-semibold">{user?.name}</Pill>
        <span className="text-xs text-grey-base">{actionLabel}</span>
        <p className="text-xs text-grey-base border border-grey-lighter rounded-sm px-2 py-1">
          {renderValueChange(actionType, displayOldValue, displayNewValue)}
        </p>
      </div>
      <span className="text-xs text-grey-base">{formattedTime}</span>
    </div>
  );
};

export default AuditLogItem;
